import { render, staticRenderFns } from "./InspectionProgress.vue?vue&type=template&id=23877ccc&scoped=true"
import script from "./InspectionProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionProgress.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionProgress.vue?vue&type=style&index=0&id=23877ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23877ccc",
  null
  
)

export default component.exports